(() => {
  document.documentElement.dataset.spiritRoutingReady = '1';
  if (!location.pathname.includes('/products/personalized-school-spirit-long-sleeve-png-bundle')) return;
  const values = {
    'properties[_Personalization Profile]': 'long_sleeve_complete',
    'properties[_Template ID]': 'sports-lower-arc-polka-mascot-script-school-v2',
    'properties[_Template Version]': '1'
  };
  const bindForms = () => {
    const forms = new Set();
    document.querySelectorAll('input').forEach((input) => {
      if (values[input.name] !== undefined && input.form) forms.add(input.form);
    });
    forms.forEach((form) => {
      if (form.dataset.spiritRoutingBound === '1') return;
      form.dataset.spiritRoutingBound = '1';
      form.addEventListener('formdata', (event) => {
        Object.entries(values).forEach(([name, value]) => event.formData.set(name, value));
      });
    });
    document.documentElement.dataset.spiritRoutingForms = String(forms.size);
  };
  bindForms();
  document.addEventListener('DOMContentLoaded', bindForms);
  document.addEventListener('shopify:section:load', bindForms);
  setTimeout(bindForms, 500);
})();